import { readonly } from 'vue';
import ErrorModal from '@/components/ErrorModal';
import { useModal } from '@/composables/useModal';
import generateRandomString from '@/utils/generateRandomString';
/** @import { ICustomError } from '@/types/definitions'; */

/**
 * @returns {ICustomError}
 */
export function useAppError() {
  const modal = useModal();
  const errors = useState('global-errors', () => []);

  /**
   *
   * @param {string} id - ID of error
   * @returns {void} - This function does not return anything
   */
  function clearError(id) {
    errors.value = [...errors.value.filter((err) => err.id === id)];
  }

  /**
   *
   * @param {Error} err - The error object containing details of the error
   * @returns {void} - This function does not return anything
   */
  function showModalError(err) {
    errors.value = [...errors.value, err];
    // TODO use actual logger
    console.error(err);
    modal.showModal({
      id: `global-error-dialog-${generateRandomString()}`,
      title: "That wasn't supposed to happen...",
      body: ErrorModal,
      width: '38rem',
    });
  }

  /**
   * @returns {void} - This function does not return anything
   */
  function listenErrorCaptured() {
    // onErrorCaptured((err) => false);
    // TODO use actual logger
    // console.error(err); // commented due to reference error on brand index pages
    // TODO remove if app.config.errorHandler will be implemented
  }

  return {
    listenErrorCaptured,
    clearError,
    showModalError,
    errors: readonly(errors),
  };
}

export default useAppError;
